import React from 'react';
import constants from '../../constants';
//shared tooltip component
const SingleUserOwnedNFT = ({
  item,
  type,
  action = undefined,
  isClickable = false,
  contentClassName = undefined,
  isConfigurator=false
}) => {
  //const [isSelected, setIsSelected] = React.useState(false);
  //console.log("Chaild is rending ")
  return (
    <div className={`position-relative content ${contentClassName && contentClassName}`}>
      <div
        className={`latest-games-items mb-30 ${isClickable && 'cursor-pointer'} ${
          item.isSelected && isClickable ? 'selectedNFT' : 'notSelectedNFT'
        }`}
        onClick={() => {
          isClickable&&!item?.isSelected&& action(item.isSelected && isClickable ? false : true, item.tokenId.toString());
        }}
      >
        <div className="latest-games-thumb">
          <img src={item.image} alt="" />
          {item.isSelected && isClickable && (
            <i className="fas fa-times-circle remove-select"
              onClick={(e) => {e.stopPropagation();
                action(item?.isSelected && isClickable ? false : true, item.tokenId.toString());
              }}></i>
          )} 
          <div className="content-overlay"></div>
        </div>
        <div className="content-details fadeIn-bottom">
          <p className="content-text">
            {constants[item.name.split(' ').join('_')]}
          </p>
        </div>

      {!isConfigurator&&   <div className="latest-games-content">
        <div className="label-with-bg">{type}</div>

        <h4>{item.name}</h4>
          {item?.entryFees && (
            <p>
              entry fees : <span>$25,00</span>
            </p>
          )}
        </div>}
      </div>
    </div>
  );
};

export default SingleUserOwnedNFT;
